import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NumberToTextService {

  th: any[] = [];
  dg: any[] = [];
  tn: any[] = [];
  tw: any[] = [];

  constructor() {
    this.th = ['', 'thousand', 'million', 'billion', 'trillion'];
    this.dg = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
    this.tn = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
    this.tw = ['twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
  }

  arabicNumberToTextTh(value: string): string {
    var number = this.checkNumber(value);
    var numberArray = new Array("ศูนย์", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า", "สิบ");
    var digitArray = new Array("", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน");
    var bahtText: string = "";
    var numberArr: any[] = [];
    var decimalLen: number;
    if (isNaN(number)) {
      return "ข้อมูลนำเข้าไม่ถูกต้อง";
    } else {
      if ((number - 0) > 9999999.9999) {
        return "ข้อมูลนำเข้าเกินขอบเขตที่ตั้งไว้";
      } else {
        numberArr = this.checkDecimal(number.toString()).split(".");
        if (numberArr[1].length > 0) {
          if (parseInt(numberArr[1].substring(1, 2)) > 4) {
            let valueTmp = parseInt(numberArr[1].substring(0, 2)) + 1;
            numberArr[1] = valueTmp.toString();
          } else {
            numberArr[1] = numberArr[1].substring(0, 2);
          }
        }
        var numberLen = numberArr[0].length - 0;
        for (var i = 0; i < numberLen; i++) {
          var tmp = numberArr[0].substring(i, i + 1) - 0;
          if (tmp != 0) {
            if ((i == (numberLen - 1)) && (tmp == 1)) {
              bahtText += "เอ็ด";
            } else
              if ((i == (numberLen - 2)) && (tmp == 2)) {
                bahtText += "ยี่";
              } else
                if ((i == (numberLen - 2)) && (tmp == 1)) {
                  bahtText += "";
                } else {
                  bahtText += numberArray[tmp];
                }
            bahtText += digitArray[numberLen - i - 1];
          }
        }
        bahtText += "บาท";
        if ((numberArr[1] == "0") || (numberArr[1] == "00")) {
          bahtText += "ถ้วน";
        } else {
          decimalLen = numberArr[1].length - 0;
          for (var i = 0; i < decimalLen; i++) {
            var tmp = numberArr[1].substring(i, i + 1) - 0;
            if (tmp != 0) {
              if ((i == (decimalLen - 1)) && (tmp == 1)) {
                bahtText += "เอ็ด";
              } else
                if ((i == (decimalLen - 2)) && (tmp == 2)) {
                  bahtText += "ยี่";
                } else
                  if ((i == (decimalLen - 2)) && (tmp == 1)) {
                    bahtText += "";
                  } else {
                    bahtText += numberArray[tmp];
                  }
              bahtText += digitArray[decimalLen - i - 1];
            }
          }
          bahtText += "สตางค์";
        }
        return bahtText;
      }
    }
  }

  checkNumber(number: string): number {
    var numberStr = number + ''
    numberStr = numberStr.replace(/ |,|บาท|฿/gi, '');
    return parseFloat(numberStr);
  }


  checkDecimal(numberStr: string): string {
    var decimal = false;
    for (var i = 0; i < numberStr.length; i++) {
      if (numberStr[i] == '.') {
        decimal = true;
      }
    }
    if (decimal == false) {
      numberStr = numberStr + '.00';
    }
    return numberStr;
  }

  arabicNumberToTextEn(value: any) {
    value = value.toString();
    value = value.replace(/[\, ]/g, '');
    if (value != parseFloat(value)) return 'not a number';
    var x = value.indexOf('.');
    if (x == -1) x = value.length;
    if (x > 15) return 'too big';
    var n = value.split('');
    var str = '';
    var sk = 0;
    for (let i = 0; i < x; i++) {
      if ((x - i) % 3 == 2) {
        if (n[i] == '1') {
          str += this.tn[Number(n[i + 1])] + ' ';
          i++;
          sk = 1;
        }
        else if (n[i] != 0) {
          str += this.tw[n[i] - 2] + ' ';
          sk = 1;
        }
      }
      else if (n[i] != 0) {
        str += this.dg[n[i]] + ' ';
        if ((x - i) % 3 == 0) str += 'hundred ';
        sk = 1;
      }

      if ((x - i) % 3 == 1) {
        if (sk) str += this.th[(x - i - 1) / 3] + ' ';
        sk = 0;
      }
    }
    if (x != value.length) {
      var y = value.length;
      str += 'point ';
      for (let i = x + 1; i < y; i++) str += this.dg[n[i]] + ' ';
    }
    return str.replace(/\s+/g, ' ');
  }

}
